<template>
    <div ref="customDiv" v-bind="$attrs">
        <div class="popover">
            <transition name="fade" mode="out-in" appear>
                <div v-if="showPopup" @click.stop>
                  <slot name="content" v-bind="{ toggle }"/>
                </div>
            </transition>

          <button @click="toggle" class="popover-button">
            <transition name="fade" mode="out-in" appear>
                <i v-if="showPopup" class="mdi  mdi-chevron-down"></i>

                <slot v-else name="button">
                    <i class="mdi mdi-chevron-up"></i>
                </slot>
            </transition>
          </button>
        </div>

    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        showPopup: false
      };
    },
    methods: {
      toggle() {
        this.showPopup = !this.showPopup;
      }
    }
  }
  </script>

<style lang="scss" scoped>
@import "~@scss/variables.scss";

.popover {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.popover-button {
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: var(--support-primary, #{$vivo-purple});
    color: var(--support-foreground, white);

    &:hover {
        background: var(--support-primary-hover, var(--support-primary, #{$vivo-purple}));
    }
}

.mdi {
    font-size: 32px;
}

.mdi-chevron-down {
        padding: 4px 12px 0px 12px;
}


.fade-enter-active,
.fade-leave-active {
    opacity: 1;
    transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
